module.exports = __webpack_public_path__ + "img/moreinfo.ca40ca3e.svg";